export const PhoneNumberField = {
  Organization: 'organization.phoneNumber',
  CustomerReference: 'customerReference.phoneNumber',  
  JointNominee: 'jointNominee.phoneNumber',
} as const;

export type PhoneNumberFieldId = typeof PhoneNumberField[keyof typeof PhoneNumberField];
